import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import moment from 'moment';
import messages from 'aurora-translations';
import { ADGMPanelInputsGeneratorBody } from 'aurora-components';
import { numberMaskWithoutDecimalOption } from 'aurora-utils/constants';

const UAEResidentBuyerEditDetails = ({ intl, classes, locale, buyer, onChangeHandler }) => {
  const BUYER_DETAILS_SECTIONS = useMemo(() => {
    return [
      {
        fields: [
          {
            type: 'text',
            label: intl.formatMessage({ ...messages.eid_moi_num }),
            placeholder: intl.formatMessage({ ...messages.eid_moi_num }),
            value: buyer?.eid,
            required: true,
            disabled: true,
          },
          {
            type: 'text',
            label: intl.formatMessage({ ...messages.Name_English_bracket }),
            placeholder: intl.formatMessage({ ...messages.Name_English_hint }),
            value: buyer?.nameEn,
            required: true,
            disabled: true,
          },
          {
            type: 'text',
            label: intl.formatMessage({ ...messages.Name_Arabic_bracket }),
            placeholder: intl.formatMessage({ ...messages.Name_Arabic_hint }),
            value: buyer?.nameAr,
            required: true,
            disabled: true,
          },
          {
            type: 'text',
            label: intl.formatMessage({ ...messages.Nationality }),
            placeholder: intl.formatMessage({ ...messages.Nationality }),
            value: locale === 'en' ? buyer?.nationalityEn : buyer?.nationalityAr,
            required: true,
            disabled: true,
          },
          {
            type: 'text',
            label: intl.formatMessage({ ...messages.Date_of_birth_DD_MM_YYYY }),
            placeholder: intl.formatMessage({ ...messages.DD_MM_YYYY }),
            value: moment(buyer?.birthDate).isValid() ? moment(buyer?.birthDate).format('DD/MM/YYYY') : '',
            required: true,
            disabled: true,
          },
          {
            type: 'text',
            label: intl.formatMessage({ ...messages.Passport_issue_date }),
            placeholder: intl.formatMessage({ ...messages.DD_MM_YYYY }),
            value: moment(buyer?.passportIssueDate).isValid()
              ? moment(buyer?.passportIssueDate).format('DD/MM/YYYY')
              : '',
            required: true,
            disabled: true,
          },
          {
            type: 'text',
            label: intl.formatMessage({ ...messages.Passport_expiry_date }),
            placeholder: intl.formatMessage({ ...messages.DD_MM_YYYY }),
            value: moment(buyer?.passportExpiryDate).isValid()
              ? moment(buyer?.passportExpiryDate).format('DD/MM/YYYY')
              : '',
            required: true,
            disabled: true,
          },
          {
            type: 'text',
            label: intl.formatMessage({ ...messages.phone_number }),
            placeholder: intl.formatMessage({ ...messages.phone_number }),
            value: buyer?.phoneNumber,
            mask: createNumberMask(numberMaskWithoutDecimalOption),
            onChange: e => onChangeHandler('phoneNumber', e?.target?.value),
            required: true,
          },
          {
            type: 'text',
            label: intl.formatMessage({ ...messages.Email }),
            placeholder: intl.formatMessage({ ...messages.Email }),
            value: buyer?.email,
            onChange: e => onChangeHandler('email', e?.target?.value),
            required: true,
          },
        ],
      },
    ];
  }, [intl, buyer]);

  return (
    <ADGMPanelInputsGeneratorBody
      isEditable
      sections={BUYER_DETAILS_SECTIONS}
      bodyStyle={classes.buyerDetailsContent}
    />
  );
};

UAEResidentBuyerEditDetails.propTypes = {
  intl: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  buyer: PropTypes.object.isRequired,
  onChangeHandler: PropTypes.func.isRequired,
};

export default UAEResidentBuyerEditDetails;
